var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75375 17C3.54292 17 3.36458 16.9285 3.21875 16.7854C3.07292 16.6425 3 16.4653 3 16.2537V14.4444C3 14.2453 3.03472 14.0556 3.10417 13.875C3.17361 13.6944 3.28472 13.5278 3.4375 13.375L13.375 3.4375C13.5278 3.28472 13.6933 3.17361 13.8717 3.10417C14.0499 3.03472 14.2374 3 14.4342 3C14.6308 3 14.8194 3.03472 15 3.10417C15.1806 3.17361 15.3472 3.28472 15.5 3.4375L16.5625 4.5C16.7153 4.65278 16.8264 4.81944 16.8958 5C16.9653 5.18056 17 5.36486 17 5.55292C17 5.75361 16.9651 5.94486 16.8954 6.12667C16.8257 6.30847 16.7147 6.47458 16.5625 6.625L6.625 16.5625C6.47222 16.7153 6.3059 16.8264 6.12604 16.8958C5.94618 16.9653 5.75701 17 5.55854 17H3.75375ZM14.4375 6.625L15.5 5.5625L14.4375 4.5L13.375 5.5625L14.4375 6.625Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.61468e84e506e7ebb713711115bf822d.svg";
export { ForwardRef as ReactComponent };